import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    branch: [],
    lastQuery: null,
};

const getters = {
    branches(state) {
        return state.branch;
    },
};

const mutations = {
    setBranch(state, data) {
        state.branch = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const actions = {
    async getBranchListIfNecessary({ commit, dispatch, state }, params = {}) {
        if (!state.branch.length || state.lastQuery != params.query) {
            return dispatch('getBranch', params);
        }

        return Promise.resolve(state.branch);
    },

    async getBranch({ commit, dispatch }, params) {
        let route = Laroute.route('admin.branch');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'branch_loading');

        try {
            const res = await axios.get(route, options);
            commit('setBranch', res.data.data);
            commit('setLastQuery', options.params.query);
            return res.data.data; // Ensure to return the correct data
        } catch (err) {
            throw err;
        } finally {
            endLoading(dispatch, 'branch_loading');
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/branch.js